"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOG_POST_FIELDS = void 0;
const client_1 = require("@apollo/client");
const picture_1 = require("./picture");
exports.BLOG_POST_FIELDS = (0, client_1.gql) `
  ${picture_1.PICTURE_FIELDS}
  fragment BlogPostFields on BlogPost {
    id
    createdAt
    updatedAt
    title
    slug
    pictureId
    meta {
      title
      description
    }
    picture {
      ...PictureFields
    }
    body
    tags {
      id
      name
    }
  }
`;
